import type { InputElementInterface } from './types'

import styled from 'styled-components'

import { baseInputCSS } from './base-input-css'

export const TextInput = styled.input<InputElementInterface>`
  ${baseInputCSS}
`
